import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { playSound } from '../../utils/audio-helper';
import './index.css';

const CRLandingScreen = props => {

	const { transitionOut, sounds } = props;
	let [homepageClassName, setHomepageClassName] = useState('');

	const handleAnimationEnd = evt => {
		const { animationName } = evt;
		// console.log('handleAnimationEnd', evt, animationName);

		if (animationName === 'gameboard-slideshow') {
			setHomepageClassName(' fade-out');
		} else {
			transitionOut();
		}
	}

	useEffect(()=>{
		playSound(sounds, 'intro_theme');
	}, []);

	return (
		<div className={'cr-homepage' + homepageClassName} onAnimationEnd={handleAnimationEnd}>
			<div className="cr-logo"><gsntv-wc-tune-in show-id="chain-reaction"></gsntv-wc-tune-in></div>
			<div className="cr-homepage-gameboard">Complete the word chain to win the game</div>
			<div className="cr-homepage-host"></div>
		</div>
	)
}

export default CRLandingScreen;


// WEBPACK FOOTER //
// ./src/components/CRLandingScreen/index.jsx